export default "mutation LoginAnonymous($siteId: ID!){\nloginAnonymous(siteId: $siteId){\nsiteId\ntoken\nexpiration\nroles\n# ip\ntrusted\n}\n}\n"